<template>
    <div class="row">
        <div class="col-12">
            <label class="form-label">Gösterge Türü</label>
            <v-select-list placeholder="Gösterge Türü" v-model="type" label="name" :options="c_types"/>
        </div>
        <div class="col-12 text-right mt-1" v-if="value.EntityFileType">
            <button class="btn btn-sm btn-flat-success" v-on:click="getSample">
                <feather-icon icon="FileIcon"></feather-icon>
                Örnek Excel
            </button>
        </div>
        <div class="col-12 mt-50" v-if="value.EntityFileType">
            <v-file-uploader :accept="['xls','xlsx']" v-model="value" value-parameter="File"></v-file-uploader>
        </div>
    </div>
</template>

<script>
import VFileUploader from '@/components/v-file-uploader/VFileUploader'
import InflationApi from '@/api/inflation'
import Additional from '@/utilities/additional'
export default {
    components:{
        VFileUploader,
    },
    props:{
        value:Object,
        groups:Array,
    },
    methods:{
        getSample(){
            InflationApi.GetSampleExcel().then(res=>{
                Additional.DownloadFile(res.data,'EnflasyonGöstergeleri.xlsx')
            })
        },
    },
    computed:{
        c_types(){
            return this.groups.find(g=>g.name == "YILLIK").types
        },
        type:{
            get:function(){
                return this.c_types.find(b=>b.key==this.value.key)
            },
            set:function(value){
                this.value.EntityFileType = value?.key || null
            }  
        }
    }
}
</script>

<style lang="scss">
</style>